<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('ipDomainCerts.pageTitleText') }}
            p {{ $t('ipDomainCerts.pageDescription') }}

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="$store.getters.isAdmin"
            :userCanIndex="true"
            :userCanDelete="true"
            :userCanExport="$store.getters.isAdmin"
            :actionInTable="true"
            :userCanBatchEdit="false"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            createApiAction="createIpDomainCert"
            primarySearchKey="keypairname"
            :primarySearchKeyI18="$t('certsmanage.keypairname')"
            :isEditBtnDisabled="false"
        )
</template>
<script>
import Vue from "vue";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import DownloadCertBtn from "@/components/DownloadCertBtn";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import IpDomainValidationStatus from "@/components/IpDomainValidationStatus";
import bus from "@/libs/bus.js";

Vue.component("TagList", TagList);
Vue.component("DownloadCertBtn", DownloadCertBtn);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("IpDomainValidationStatus", IpDomainValidationStatus);

import { settingZoneExplain, action, commonName, validityStart, validityEnd } from "./fields.js";

export default {
    name: "IpDomainCertsApply",
    components: { RcmTable },
    data() {
        return {
            esIndex: "rcm-certpems",
            drawerTitleKey: "keypairname",
            sort: [{ modifiedDate: { order: "desc" } }]
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("ipDomainCerts.applyBtnText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            return {
                action: action(this),
                settingZoneExplain: settingZoneExplain(this),
                groupName: { withForm: false, formTypes: [] },
                groupNames: {},
                createBy: {},
                keypairname: {},
                sslProvider: {},
                commonName: commonName(this),
                ipDomainList: {},
                ipDomainValidation: {},
                validityStart: validityStart(this),
                validityEnd: validityEnd(this),
                expiredDays: {},
                certRaw: {},
                status: {},
                createdDate: {},
                modifiedDate: {},
                certUsedByEdge: {},
                certUsedByGroup: {},
                _id: {},
                objectLog: {}
            };
        }
    },
    methods: {},
    created() {
        bus.$on(this.$options.name, busEvent => {
            bus.$emit(busEvent);
        });
    },
    beforeDestroy() {
        bus.$off(this.$options.name);
    }
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/view/IpDomainCerts/Page.vue